import { useEffect } from 'react';

export const useClickOutside = (ref: React.RefObject<HTMLElement | null>, callbackFn: () => void) => {
  useEffect(() => {
    if (!ref) return;
    const listener = (event: MouseEvent | TouchEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callbackFn();
      }
    };

    window.addEventListener('mousedown', listener);
    window.addEventListener('touchstart', listener);

    return () => {
      window.removeEventListener('mousedown', listener);
      window.removeEventListener('touchstart', listener);
    };
  }, [ref, callbackFn]);
};

export default useClickOutside;
